import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Container} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2Mistakes.module.scss'
const cx = cn.bind(s)

interface IW2MistakesProps {
	className?: string
	content: IW2Content['mistakes']
}

/** W2Mistakes block component */
const W2Mistakes: FC<IW2MistakesProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} subtitle={content?.subtitle} />
				<div className={s.items}>
					{content?.items?.map((item) => {
						return item.list && <PortableBlocks key={item._key} blockContent={item.list} />
					})}
				</div>
			</Container>
		</div>
	)
}

W2Mistakes.displayName = 'W2Mistakes'

export default W2Mistakes
